(ns teamoesterreich.admin-mode.lebensretter.incident.incident-map
  (:require [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            ))






(defn get-update-map-content [elms !marker gmap search filter !selected]
  (doseq [[id m] @!marker]
    (.setMap m nil))

  (log/debug "set marker  : " (count elms) " sel " @!selected)
  (let [markers (reduce (fn [c u] (let [marker (js/google.maps.Marker.
                                                     (clj->js
                                                                {:title    (str (get u "incident-external-id") "\n" (get u "incident-message") " \n")
                                                                 :position (js/google.maps.LatLng. (get u "incident-latitude") (get u "incident-longitude"))
                                                                 :id       (get u "incident-uuid")
                                                                 :icon     (if (= @!selected (get u "incident-uuid")) "/custom/img/attack_sel.png" "/custom/img/attack.png")
                                                                 }))]
                                        (.setMap marker gmap)
                                        (js/google.maps.event.addListener marker "click" #(reset! !selected (get u "incident-uuid")))
                                        (assoc c (get u "incident-uuid") marker)
                                        ))
                        {}
                        elms
                        )]
    ;(log/debug "markers" markers)
    (reset! !marker markers)))



(defn gmap-component [!st]
  (let [!search (r/cursor !st [:search])
        !centerMap (r/cursor !st [:center-map])
        !filter (r/cursor !st [:filter])
        !selected (r/cursor !st [:selected])
        !elems (r/cursor !st [:elems])
        !marker (atom {})
        ]
    ;(log/debug "Mount gmap " @!search @!filter )
    (let [gmap (atom nil)
          options (clj->js {"center" v-state/MAP_CENTER
                            "zoom"   v-state/MAP_ZOOM})
          update (fn [& [parm parm2 new]]
                   (log/debug "UPDATE !centerMap?" (clj->js parm) (clj->js parm2) " NEW: " (clj->js new))
                   (when (and new (:center-map new) (not-empty (:center-map new)))
                     (.setCenter (:map @gmap) (js/google.maps.LatLng. (:lat (:center-map new)) (:lng (:center-map new))))
                     (.setZoom (:map @gmap) (:zoom (:center-map new)))
                     (reset! !centerMap {})
                     )
                   (if new
                     (get-update-map-content @!elems !marker (:map @gmap) (:search new) (:filter new) !selected)
                     (get-update-map-content @!elems !marker (:map @gmap) @!search @!filter !selected)
                     ))]


      ;(update)
      (add-watch !st :atom-change
                 (fn [k r o n]
                   ;(log/debug "Watch trigger called" k  o "->" n)
                   (when (or
                           (not= (:filter o) (:filter n))
                           (not= (:search o) (:search n))
                           (and (:center-map n) (not-empty (:center-map n)) (not= (:center-map o) (:center-map n)))
                           )
                     (when (:map @gmap)
                       (log/debug "Watch trigger fired" n)
                       (update {} {} n)))))

      ;(add-watch !search :search-change (fn [k r o n]  (when (:map @gmap) (log/debug "Watch trigger !search" n) (update {}))))

      ;;(add-watch !centerMap :centerMap-change (fn [k r o n] (log/debug "Watch trigger !centerMap" n)))

      ;(log/debug "Mount gmap watcher registered " @!search @!filter @!centerMap)


      (r/create-class
        {:reagent-render       (fn []
                                 @!search
                                 [:div#map-canvas {:style {:height "573px"}}])
         :component-did-mount  (fn [comp]
                                 (let [canvas (.getElementById js/document "map-canvas")
                                       gm (js/google.maps.Map. canvas options)]
                                   (reset! gmap {:map gm})
                                   (js/google.maps.event.addListener gm "dragend" update)
                                   (js/google.maps.event.addListener gm "zoom_changed" update)
                                   )

                                 )
         :component-did-update #(update)
         :display-name         "gmap-component"}))))

(def map-home gmap-component)
